import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Box, SxProps } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { PickersDay } from '@mui/x-date-pickers';
import { SubDateRangePickerProps } from '../../DataRangePicker/DataRangePicker';
import { CircularProgress } from '@mui/material';
import { Backdrop } from '@mui/material';
import { DateTime } from 'luxon';

export const MobileDateRangePicker = (props: SubDateRangePickerProps): JSX.Element => {
    const {
        onMonthDecrease,
        onMonthIncrease,
        startPeriod,
        endPeriod,
        startDate,
        endDate,
        slots,
        loading = false,
        onRangePositionChange,
        sxCalendar,
        slotProps
    } = props;

    const onMonthDecreaseHandler = (date: any) => {
        if (onMonthDecrease === undefined) {
            return;
        }

        onMonthDecrease(date);
    }

    const onMonthIncreaseHandler = (date: any) => {
        if (onMonthIncrease === undefined) {
            return;
        }

        onMonthIncrease(date);
    }

    const datesContainer: SxProps = {
        padding: '0 0',
        gridTemplateColumns: 'max-content 1fr',
        display: 'grid',
        fontSize: '20px',
    }

    const propertyTitle: SxProps = {
        fontWeight: '700',
        fontSize: '20px',
        margin: '0 10px 0 0'
    }

    const toDateFormat = (date: DateTime) => {
        return date.toFormat('M/dd/yyyy')
    }

    const handleStartDateClick = () => {
        if (onRangePositionChange === undefined) {
            return
        }

        onRangePositionChange('start')
    }

    const handleEndDateClick = () => {
        if (onRangePositionChange === undefined) {
            return
        }

        onRangePositionChange('end')
    }

    const Day = slots?.day ?? PickersDay;

    return (
        <>


            <Box sx={{
                display: 'grid',
                'justifyContent': 'start',
                position: 'relative',
            }}>

                <Box sx={datesContainer}>
                    <Box
                        sx={propertyTitle}
                        onClick={handleStartDateClick}
                    >
                        Start:
                    </Box>
                    <Box
                        onClick={handleStartDateClick}
                    >
                        {startDate ? toDateFormat(startDate) : ''}
                    </Box>
                    <Box
                        sx={propertyTitle}
                        onClick={handleEndDateClick}
                    >
                        End:
                    </Box>
                    <Box
                        onClick={handleEndDateClick}
                    >
                        {endDate ? toDateFormat(endDate) : ''}
                    </Box>
                </Box>

                <Box sx={{
                    display: 'grid',
                }}>
                    <Box sx={
                        {
                            display: 'flex',
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }
                    }>
                        <IconButton
                            onClick={ onMonthDecreaseHandler }
                            sx={
                                {
                                    position: 'absolute',
                                    left: '0'
                                }
                            }
                        >
                            <ArrowBackIosNewIcon />
                        </IconButton>
                        <h2>{startPeriod?.toFormat('MMMM yyyy')}</h2>
                        <IconButton
                            onClick={onMonthIncreaseHandler}
                            sx={
                                {
                                    position: 'absolute',
                                    right: '0'
                                }
                            }
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Box>
                    <DateCalendar
                        dayOfWeekFormatter={(date) => {
                            return date.toFormat('ccc').substring(0, 2);
                        }}
                        sx={sxCalendar}
                        value={startPeriod}
                        loading={loading}
                        slots={{
                            calendarHeader: () => (null),   
                            day: Day 
                        }}
                        slotProps={{

                            day: slotProps?.day || undefined
                        }}
                    />
                </Box>      

                    <Backdrop
                        sx={{
                            color: '#fff', height: '100%', position: 'absolute', width: '100%',
                        }}
                        open={loading}
                    >
                        <CircularProgress size="6rem" color="success" />
                    </Backdrop>

            </Box>
        </>
    )
}